import { API_BASE } from '../config';
const FRONT_DEFAULT_AVATAR = '/avatars/default-avatar-fallback.png';
const LOCAL_PUBLIC_AVATARS = new Set([
  '/avatars/anfisa.jpg',
  '/avatars/milana.jpg',
  '/avatars/antonio.jpg',
  '/avatars/kostik.jpg',
  FRONT_DEFAULT_AVATAR
]);

export const resolveAvatarUrl = (url) => {
  if (!url || typeof url !== 'string') return FRONT_DEFAULT_AVATAR;
  const trimmed = url.trim();
  if (!trimmed) return FRONT_DEFAULT_AVATAR;

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  if (trimmed.startsWith('/')) {
    if (trimmed.startsWith('/storage/avatars/')) {
      return `${API_BASE}${trimmed.replace('/storage/', '/')}`;
    }
    if (trimmed.startsWith('/avatars/') && LOCAL_PUBLIC_AVATARS.has(trimmed)) {
      return trimmed;
    }
    return `${API_BASE}${trimmed}`;
  }

  return `${API_BASE}/${trimmed}`;
};

export const resolveAvatarThumbUrl = (url, size = 512, fit = 'cover') => {
  if (!url || typeof url !== 'string') return FRONT_DEFAULT_AVATAR;
  const trimmed = url.trim();
  if (!trimmed) return FRONT_DEFAULT_AVATAR;

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  if (trimmed.startsWith('/')) {
    if (trimmed.startsWith('/avatars/') && LOCAL_PUBLIC_AVATARS.has(trimmed)) {
      return trimmed;
    }

    if (trimmed.startsWith('/avatars/')) {
      const safeSize = Number.isFinite(size) ? Math.max(64, Math.min(1024, Math.round(size))) : 512;
      const safeFit = fit === 'contain' ? 'contain' : 'cover';
      return `${API_BASE}/api/media/avatar-thumb?url=${encodeURIComponent(trimmed)}&size=${safeSize}&fit=${safeFit}`;
    }

    return `${API_BASE}${trimmed}`;
  }

  return `${API_BASE}/${trimmed}`;
};

export const withAvatarFallback = (fallback = FRONT_DEFAULT_AVATAR) => (e) => {
  const target = e?.currentTarget;
  if (!target) return;
  target.onerror = null;
  target.src = fallback;
};

export { FRONT_DEFAULT_AVATAR };
